<template>
  <div>
    <el-descriptions
      class="margin-top"
      title="单位信息"
      border
      :column="UI.clientWidth < 1000 ? 1 : 3"
      :labelStyle="{ width: UI.clientWidth < 1000 ? '100px' : '100px' }"
    >
      <template slot="extra">
        <el-button type="primary" size="small" @click="toApproved()">
          {{
            User.organization_info.organization
              ? '认证信息提交或修改'
              : `点击认证${
                  User.user.role == $roleConsts.ORG.value ? '' : '(可选)'
                }`
          }}
        </el-button>
      </template>
      <el-descriptions-item>
        <template slot="label">
          单位名称
        </template>
        {{ User.organization_info.organization }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          单位地址
        </template>
        {{ User.organization_info.address }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          联系人
        </template>
        {{ User.organization_info.contact }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          联系电话
        </template>
        {{ User.organization_info.contact_phone }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          手机
        </template>
        {{ User.organization_info.contact_mobile }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          邮箱
        </template>
        {{ User.organization_info.email }}
      </el-descriptions-item>

      <el-descriptions-item v-if="User.user.role == $roleConsts.ORG.value">
        <template slot="label">
          认证材料
        </template>

        <el-button
          size="mini"
          :disabled="!User.organization_info.auth_file"
          @click="
            fileUrl = User.organization_info.auth_file;
            isShow = true;
          "
          :type="
            User.organization_info.auth_file
              ? approveBtn[User.organization_info.is_approved]
              : 'danger'
          "
        >
          {{
            User.organization_info.auth_file
              ? $getApproveLabel(User.organization_info.is_approved)
              : '未上传'
          }}
        </el-button>
      </el-descriptions-item>
    </el-descriptions>

    <el-dialog
      show-close
      :fullscreen="UI.isMobile"
      title="查看"
      :visible.sync="isShow"
      width="800px"
    >
      <pdf :src="fileUrl" v-if="fileUrl.endsWith('pdf')"></pdf>
      <img v-else :src="fileUrl" style="max-width: 500px;"></img>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import pdf from '@/components/pdfShow.vue';
import { showErrorMsg } from '@/utils/uiUtils.js';

export default {
  components: {
    pdf,
  },

  computed: {
    ...mapState(['User', 'UI']),
  },

  data() {
    return {
      userInfoEdit: {},
      fileUrl: '',
      isShow: false,
      approveBtn: ['warning', 'success', 'danger', 'info'],
    };
  },

  methods: {
    toApproved: function() {
      if (
          this.User.organization_info.is_approved ==
          this.$approveConsts.APPROVED.value
        ) {
          showErrorMsg('信息已审核，请先联系管理员驳回');
        } else {
          this.$router.push({ name: 'organizationApprove' });
        }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/index/info/orgInfo.vue